const CA_DASHBOARD_DEBUG = false
const CA_DASHBOARD_DEBUG_TEAM_ID = 1
const CA_DASHBOARD_AUTH_COOKIE = 'CAdashboardAuth'
const CA_DASHBOARD_ID_TOKEN_COOKIE = 'CAdashboardID'
const CA_DASHBOARD_LOGIN_URL = 'https://auth.chatacuity.com/login?response_type=token&client_id=5s6eplkpvo8aatabbdk790ou6i&redirect_uri=https://dashboard.chatacuity.com'
const CA_WEBSITE_URL = 'https://www.chatacuity.com'

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Vuex from 'vuex'
import vSelect from 'vue-select'
import { mapGetters, mapActions } from 'vuex'
import App from './App'
import router from './router/index'
import axios from 'axios'
import moment from 'moment'
import Cookies from 'js-cookie'
// import {CognitoAuth} from 'amazon-cognito-auth-js'
import 'chartjs-plugin-colorschemes'
import { applyPolyfills, defineCustomElements } from '@bruit/component/loader'

var jwtDecode = require('jwt-decode')

// axios.defaults.baseURL = 'http://192.168.1.126:8000'
// axios.defaults.baseURL = 'https://api.chatacuity.com/dashboard-dev'  // dev
axios.defaults.baseURL = 'https://api.chatacuity.com/dashboard'  // prod


Vue.use(BootstrapVue)
Vue.use(Vuex)
Vue.component('v-select', vSelect)
Vue.prototype.moment = moment  // register moment so it can be used directly in templates

// Bruit.io config
Vue.config.ignoredElements = [/bruit-\w*/]
applyPolyfills().then(() => {
  defineCustomElements(window);
});


const store = new Vuex.Store({
  state: {
    loginUrl: CA_DASHBOARD_LOGIN_URL,
    websiteUrl: CA_WEBSITE_URL,

    authTokenCookieName: CA_DASHBOARD_ID_TOKEN_COOKIE,
    authData: null,

    haveShownTrialAlert: false,

    // team data
    teamMeta: null,

    summaryData: null,
    summaryDataLoaded: false,

    // current page
    currentPage: null,

    // time period
    timePeriod: 'Day',

    // user & group filtering
    filterChanged: false,
    filterUserIds: [],

    // summary
    birdseyeSummaryData: null,
    birdseyeSummaryDataLoaded: false,

    // message activity
    birdseyeMessageActivityData: null,
    birdseyeMessageActivityLoaded: false,

    // online periods
    birdseyeTeamOnlinePeriodsData: null,
    birdseyeTeamOnlinePeriodsLoaded: false,

    socialData: null,
    socialDataLoaded: false,

    teammateDetailData: null,
    teammateDetailDataLoaded: false,

    channelDetailData: null,
    channelDetailDataLoaded: false,

    billingData: null,
    billingDataLoaded: false,

    updateSubscriptionData: null,
    updateSubscriptionDataLoaded: true  // this one actually starts true
  },
  mutations: {
    haveShownTrialAlert(state, shown) {
      state.haveShownTrialAlert = shown
    },
    authData(state, data) {
      if(state.authData !== null) {
        console.log('Cannot set authData once already set')
        return
      }
      // console.log(data)
      state.authData = data
    },
    teamMeta(state, data) {
      if(state.teamMeta !== null) {
        console.log('Cannot set team meta once already set')
        return
      }
      // console.log('setting team metadata')
      // console.log(data)
      state.teamMeta = data
    },
    updateTeamGroups(state, data) {
      if(state.teamMeta === null) {
        console.log('Team metadata has not been loaded, cannot update groups')
        return
      }
      console.log('Updating team metadata with new groups')
      state.teamMeta.groups = data
    },
    updateAutoMonitorNewChannels(state, data) {
      state.teamMeta.team.auto_monitor_new_channels = data
    },
    markChannelsAsMonitored(state, data) {
      // list of team channels likely to be larger than newly monitored, so loop through that
      for(let i=0; i< state.teamMeta.channels.length; i++) {
        if(data.includes(state.teamMeta.channels[i].id)) {
          state.teamMeta.channels[i].mon = true
        }
      }
    },

    currentPage(state, data) {
      state.currentPage = data
      console.log('set currentPage to: ' + data)
    },
    timePeriod(state, data) {
      state.timePeriod = data
      console.log('set timePeriod to: ' + data)
    },
    filterChanged(state, data) {
      state.filterChanged = data
      console.log('filter changed to: ' + data)
    },
    filterUserIds(state, data) {
      state.filterUserIds = data
      console.log('filter user ID list: ' + data)
    },

    birdseyeSummaryData(state, data) {
      state.birdseyeSummaryData = data
    },
    birdseyeSummaryDataLoaded(state, isLoaded) {
      state.birdseyeSummaryDataLoaded = isLoaded
    },

    birdseyeMessageActivityData(state, data) {
      state.birdseyeMessageActivityData = data
    },
    birdseyeMessageActivityLoaded(state, isLoaded) {
      state.birdseyeMessageActivityLoaded = isLoaded
    },

    birdseyeTeamOnlinePeriodsData(state, data) {
      state.birdseyeTeamOnlinePeriodsData = data
    },
    birdseyeTeamOnlinePeriodsLoaded(state, isLoaded) {
      state.birdseyeTeamOnlinePeriodsLoaded = isLoaded
    },

    socialData(state, data) {
      state.socialData = data
    },
    socialDataLoaded(state, isLoaded) {
      state.socialDataLoaded = isLoaded
    },

    teammateDetailData(state, data) {
      state.teammateDetailData = data
    },
    teammateDetailDataLoaded(state, isLoaded) {
      state.teammateDetailDataLoaded = isLoaded
    },

    channelDetailData(state, data) {
      state.channelDetailData = data
    },
    channelDetailDataLoaded(state, isLoaded) {
      state.channelDetailDataLoaded = isLoaded
    },

    billingData(state, data) {
      state.billingData = data
    },
    billingDataLoaded(state, isLoaded) {
      state.billingDataLoaded = isLoaded
    },

    updateSubscriptionData(state, data) {
      state.updateSubscriptionData = data
    },
    updateSubscriptionDataLoaded(state, isLoaded) {
      state.updateSubscriptionDataLoaded = isLoaded
    },

  },
  actions: {
    updateBirdsEyeSummary(context, e) {
      // console.log('fetching birdseye activity summary')
      context.commit('birdseyeSummaryDataLoaded', false)

      axios.get('/teams/' + context.getters.teamInfo.id + '/birdseye?period=' + e)
      .then(response => {
        // console.log(response.data.data)
        // let demoData = response.data.data
        // demoData.summary_chart_data = JSON.parse('{"1579140000": {"users_online": 0, "total_messages": 34}, "1579143600": {"users_online": 0, "total_messages": 8}, "1579147200": {"users_online": 0, "total_messages": 0}, "1579150800": {"users_online": 0, "total_messages": 4}, "1579154400": {"users_online": 0, "total_messages": 0}, "1579158000": {"users_online": 0, "total_messages": 0}, "1579161600": {"users_online": 0, "total_messages": 4}, "1579165200": {"users_online": 0, "total_messages": 0}, "1579168800": {"users_online": 0, "total_messages": 0}, "1579172400": {"users_online": 0, "total_messages": 12}, "1579176000": {"users_online": 0, "total_messages": 7}, "1579179600": {"users_online": 0, "total_messages": 5}, "1579183200": {"users_online": 0, "total_messages": 111}, "1579186800": {"users_online": 0, "total_messages": 35}, "1579190400": {"users_online": 0, "total_messages": 29}, "1579194000": {"users_online": 0, "total_messages": 26}, "1579197600": {"users_online": 0, "total_messages": 56}, "1579201200": {"users_online": 0, "total_messages": 19}, "1579204800": {"users_online": 0, "total_messages": 242}, "1579208400": {"users_online": 0, "total_messages": 102}, "1579212000": {"users_online": 0, "total_messages": 126}, "1579215600": {"users_online": 0, "total_messages": 54}, "1579219200": {"users_online": 0, "total_messages": 2}, "1579222800": {"users_online": 0, "total_messages": 33}, "1579226400": {"users_online": 0, "total_messages": 6}}')
        context.commit('birdseyeSummaryData', response.data.data)
        context.commit('birdseyeSummaryDataLoaded', true)
      })
    },

    updateMessageActivityData(context, args = []) {
      let [period, uids] = args
      context.commit('birdseyeMessageActivityLoaded', false)

      if(uids.length == 0) {
        var uri = '/message-stats/teams/' + context.getters.teamInfo.id + '/hour?period=' + period
      } else {
        // let uids = users.map(user => user.id)
        var uri = '/message-stats/users/' + uids.join() + '/hour?period=' + period
      }
      // console.log(uri)

      axios.get(uri)
      .then(response => {
        context.commit('birdseyeMessageActivityData', response.data.data)
        context.commit('birdseyeMessageActivityLoaded', true)
      })
    },

    updateTeamOnlinePeriodsChart(context, args = []) {
      let [period, uids] = args
      context.commit('birdseyeTeamOnlinePeriodsLoaded', false)

      if(uids.length == 0) {
        // for now, fetch the entire team
        uids = context.getters.teamMembers.map(member => member.id)
      }

      let uri = '/online-periods/users/' + uids.join() + '?period=' + period
      // console.log(uri)

      axios.get(uri)
      .then(response => {
        context.commit('birdseyeTeamOnlinePeriodsData', response.data.data)
        context.commit('birdseyeTeamOnlinePeriodsLoaded', true)
      })
    },

    updateSocialData(context, args = []) {
      let [period, uids] = args
      context.commit('socialDataLoaded', false)

      if(uids.length == 0) {
        var uri = '/social-stats/teams/' + context.getters.teamInfo.id + '?period=' + period
      } else {
        // let uids = users.map(user => user.id)
        var uri = '/social-stats/users/' + uids.join() + '?period=' + period
      }

      axios.get(uri)
      .then(response => {
        context.commit('socialData', response.data.data)
        context.commit('socialDataLoaded', true)
      })

    },

    updateTeammateDetailData(context, args = []) {
      let [period, uid] = args
      context.commit('teammateDetailDataLoaded', false)

      // just for now
      // let uid = 3
      let uri = '/users/' + uid.toString() + '/details?period=' + period

      axios.get(uri)
      .then(response => {
        context.commit('teammateDetailData', response.data.data)
        context.commit('teammateDetailDataLoaded', true)
      })
    },

    updateChannelDetailData(context, args = []) {
      let [period, cid, uids] = args
      context.commit('channelDetailDataLoaded', false)

      // grab context.getters.filterUserIds

      let uri = '/channels/' + cid.toString() + '/details?period=' + period
      if(uids.length > 0) {
        uri += '&uids=' + uids.join()
      }

      axios.get(uri)
      .then(response => {
        context.commit('channelDetailData', response.data.data)
        context.commit('channelDetailDataLoaded', true)
      })
    },

    updateBillingData(context, args = []) {
      context.commit('billingDataLoaded', false)
      let uri = '/teams/' + context.getters.teamInfo.id.toString() + '/billing'

      axios.get(uri)
      .then(response => {
        context.commit('billingData', response.data.data)
        context.commit('billingDataLoaded', true)
      })
    },

    startBillingSubscriptionSession(context, args = []) {
      context.commit('updateSubscriptionDataLoaded', false)
      let uri = '/teams/' + context.getters.teamInfo.id.toString() + '/billing/subscribe'

      axios.post(uri)
      .then(response => {
        context.commit('updateSubscriptionData', response.data.data)
        context.commit('updateSubscriptionDataLoaded', true)
      })
    },


    createNewUserGroup(context, args = []) {
      console.log('posting new user group to API')
      let [name, description, users] = args
      let uri = 'teams/' + context.getters.teamInfo.id + '/groups'
      axios.post(uri, {
        name: name,
        description: description,
        members: users
      }).then(response => {
        console.log(response)
        if(response.status == 200) {
          axios.get('/teams/' + context.getters.teamInfo.id)
          .then(response => {
            context.commit('updateTeamGroups', response.data.data.groups)
          })
        }
        
      })
    },

    updateUserGroup(context, args = []) {
      console.log('sending modified user group to API')
      let [groupId, name, description, users] = args
      let uri = 'teams/' + context.getters.teamInfo.id + '/groups/' + groupId
      axios.put(uri, {
        name: name,
        description: description,
        members: users
      }).then(response => {
        console.log(response)
        if(response.status == 200) {
          axios.get('/teams/' + context.getters.teamInfo.id)
          .then(response => {
            context.commit('updateTeamGroups', response.data.data.groups)
          })
        }
        
      })
    },

    deleteUserGroup(context, groupId) {
      console.log('posting group ID: ' + groupId + ' deletion to API')
      let uri = 'teams/' + context.getters.teamInfo.id + '/groups/' + groupId

      axios.delete(uri)
      .then(response => {
        console.log(response)
        if(response.status == 200) {
          axios.get('/teams/' + context.getters.teamInfo.id)
          .then(response => {
            context.commit('updateTeamGroups', response.data.data.groups)
          })
        }
      })
    }
  },
  getters: {
    haveShownTrialAlert: state => {
      return state.haveShownTrialAlert
    },
    loginUrl: state => {
      return state.loginUrl
    },
    websiteUrl: state => {
      return state.websiteUrl
    },
    authTokenCookieName: state => {
      return state.authTokenCookieName
    },
    authData: state => {
      return state.authData
    },
    authUserId: state => {
      return state.authData['cognito:username']
    },
    authTeamId: state => {
      return parseInt(state.authData['custom:team_id'])
    },
    teamLoaded: state => {
      return state.teamMeta !== null
    },
    teamInfo: state => {
      // for some reason this occasionally throws a console error.  _something_ is referencing
      // it early on in the page load.  possibly the vue debugger?
      return state.teamMeta === null ? null : state.teamMeta.team
    },
    teamMembers: state => {
      return state.teamMeta.users
    },
    nonDeletedTeamMembers: state => {
      return state.teamMeta.users.filter(member => member.is_deleted === false)
    },
    teamGroups: state => {
      return state.teamMeta.groups
    },
    teamChannels: state => {
      return state.teamMeta.channels
    },
    teamMember: (state) => (id) => {
      // lookup team member by numeric ID
      return state.teamMeta.users.find(member => member.id == id)
    },
    teamMemberBySlackId: (state) => (slackId) => {
      // lookup team member by numeric ID
      return state.teamMeta.users.find(member => member.slack_id == slackId)
    },
    teamGroup: (state) => (id) => {
      return state.teamMeta.groups.find(group => group.id == id)
    },
    teamChannel: (state) => (id) => {
      // lookup team member by numeric ID
      return state.teamMeta.channels.find(channel => channel.id == id)
    },
    teamChannelBySlackId: (state) => (slackId) => {
      // lookup team member by numeric ID
      return state.teamMeta.channels.find(channel => channel.slack_id == slackId)
    },

    currentPage: state => {
      return state.currentPage
    },
    timePeriod: state => {
      return state.timePeriod
    },
    filterUserIds: state => {
      return state.filterUserIds
    },
    filterChanged: state => {
      return state.filterChanged
    },

    birdseyeSummaryDataLoaded: state => {
      return state.birdseyeSummaryDataLoaded
    },
    birdseyeSummaryData: state => {
      return state.birdseyeSummaryData
    },
    birdseyeMessageActivityLoaded: state => {
      // console.log('in vuex birdseyeMessageActivityLoaded getter, value: ' + state.birdseyeMessageActivityLoaded)
      return state.birdseyeMessageActivityLoaded
    },
    birdseyeMessageActivityData: state => {
      // console.log('in vuex birdseyeMessageActivityData getter')
      return state.birdseyeMessageActivityData
    },

    birdseyeTeamOnlinePeriodsLoaded: state => {
      // console.log('in vuex birdseyeTeamOnlinePeriodsLoaded getter, value: ' + state.birdseyeTeamOnlinePeriodsLoaded)
      return state.birdseyeTeamOnlinePeriodsLoaded
    },
    birdseyeTeamOnlinePeriodsData: state => {
      // console.log('in vuex birdseyeTeamOnlinePeriodsData getter')
      return state.birdseyeTeamOnlinePeriodsData
    },

    socialDataLoaded: state => {
      return state.socialDataLoaded
    },
    socialData: state => {
      return state.socialData
    },

    teammateDetailDataLoaded: state => {
      return state.teammateDetailDataLoaded
    },
    teammateDetailData: state => {
      return state.teammateDetailData
    },

    channelDetailDataLoaded: state => {
      return state.channelDetailDataLoaded
    },
    channelDetailData: state => {
      return state.channelDetailData
    },

    billingDataLoaded: state => {
      return state.billingDataLoaded
    },
    billingData: state => {
      return state.billingData
    },

    updateSubscriptionDataLoaded: state => {
      return state.updateSubscriptionDataLoaded
    },
    updateSubscriptionData: state => {
      return state.updateSubscriptionData
    }

  }
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  store: store,
  router,
  template: '<App/>',
  components: {
    App
  },
  mounted() {
    console.log('mounted main app!')

    /*
    For now, going to send the cognito username with each request rather than use the
    cognito user pool authorizer on API Gateway.  To use that, we cannot use the implicit
    grant that provides an id_token, we would have to go the 'code' route where the hosted
    login page returns a code instead of a token.  The code is then submitted to a backend 
    endpoint we would have to create that sends it to Cognito
    in exchange for access, refresh, and id tokens.  Currently, we use the 'token' route, 
    where the hosted login sends an ID token with all the data the dashboard needs.  However,
    this token expires after 1 hour and a refresh token is required to get a new ID token.

    Instead of building all this logic & additional endpoint(s), just going to send the 
    username (big UUID lookin thing) as an X-header.  The chalice app can use the cognito-idp
    admin_get_user() method to validate the user and it's associated team ID.

    https://docs.aws.amazon.com/cognito/latest/developerguide/cognito-user-pools-app-idp-settings.html
    https://docs.aws.amazon.com/cognito/latest/developerguide/token-endpoint.html
    https://docs.aws.amazon.com/cognito/latest/developerguide/amazon-cognito-user-pools-using-tokens-with-identity-providers.html#amazon-cognito-user-pools-using-the-id-token
    https://stackoverflow.com/questions/37442973/cognito-user-pool-how-to-refresh-access-token-using-refresh-token
    https://github.com/aws/amazon-cognito-auth-js/issues/52
    https://github.com/aws-amplify/amplify-js/issues/1231
    https://boto3.amazonaws.com/v1/documentation/api/latest/reference/services/cognito-idp.html#CognitoIdentityProvider.Client.admin_get_user
    https://forum.serverless.com/t/how-to-use-aws-cognito-refresh-token/4327/2
    https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference//API_InitiateAuth.html
    https://docs.aws.amazon.com/apigateway/latest/developerguide/apigateway-integrate-with-cognito.html
    https://stackoverflow.com/questions/52765636/api-created-with-chalice-and-a-cognito-authorizer-returns-unauthorized
    */
    let url = window.location.href
    let tokenMatches = url.match(/id_token=[^&]*&/)
    if(tokenMatches == null) {
      // we were not forwarded here from hosted cognito login

      // check for cookie
      let savedAuth = Cookies.get(CA_DASHBOARD_ID_TOKEN_COOKIE)
      if(savedAuth === undefined) {
        // no token, no auth cookie, direct them to login page!
        console.log('no auth cookie found, redirecting to login')
        window.location = CA_DASHBOARD_LOGIN_URL
        return
      } else {
        console.log('auth id cookie present')

        let decodedToken = jwtDecode(savedAuth) // JSON.parse(savedAuth)
        store.commit('authData', decodedToken)
      }

    } else {
      // we were just forwarded here from the cognito login page
      var cognitoAuthToken = tokenMatches[0]
      cognitoAuthToken = cognitoAuthToken.slice(9, -1) // id_token= and trailing &
      // console.log(cognitoAuthToken)
      let decodedToken = jwtDecode(cognitoAuthToken)
      // console.log(decodedToken)
      Cookies.set(CA_DASHBOARD_ID_TOKEN_COOKIE, cognitoAuthToken, { expires: 1 })

      store.commit('authData', decodedToken)

      // let r = JSON.parse(Cookies.get('CAdashboardAuth'))
      // console.log(r)
      router.push({ name: 'Home' })
    }

    // console.log('passed auth logic')


    // throw new Error('Stop!');

    /*
    var authData = {
      ClientId : '5s6eplkpvo8aatabbdk790ou6i',
      AppWebDomain : 'auth.chatacuity.com',
      UserPoolId : 'us-east-2_C0AI1FPeK',
      TokenScopesArray : ['phone', 'email', 'profile','openid', 'aws.cognito.signin.user.admin'],
      RedirectUriSignIn : '<TODO: add redirect url when signed in>',
      RedirectUriSignOut : '<TODO: add redirect url when signed out>',
      AdvancedSecurityDataCollectionFlag : false,
      // Storage: '<TODO the storage object>' // OPTIONAL e.g. new CookieStorage(), to use the specified storage provided
    }
    var auth = new CognitoAuth(authData)
    var curUrl = window.location.href
    var curUrl = 'https://dashboard.chatacuity.com/id_token=eyJraWQiOiJBd2UrY2JtVElOZmdJcG05dkVEYnZmckhNQkVnMHhIVGlObXA2ZEI1Rk9BPSIsImFsZyI6IlJTMjU2In0.eyJhdF9oYXNoIjoiS052VE5vRGJPbDJkeWV2VW1IUGRRUSIsInN1YiI6IjY3MzRiYTUzLTQ1MDItNDQ4Ni1hOGE0LWI1NGZiMGZiMmZiZSIsImF1ZCI6IjVzNmVwbGtwdm84YWF0YWJiZGs3OTBvdTZpIiwiZXZlbnRfaWQiOiI4YjgwNTI5MS03OTJkLTQxYmUtYTgyMy1mNzJiNTlhMjJlODMiLCJ0b2tlbl91c2UiOiJpZCIsImF1dGhfdGltZSI6MTU3MzY3Mzk3MywiaXNzIjoiaHR0cHM6XC9cL2NvZ25pdG8taWRwLnVzLWVhc3QtMi5hbWF6b25hd3MuY29tXC91cy1lYXN0LTJfQzBBSTFGUGVLIiwiY29nbml0bzp1c2VybmFtZSI6IjY3MzRiYTUzLTQ1MDItNDQ4Ni1hOGE0LWI1NGZiMGZiMmZiZSIsImV4cCI6MTU3MzY3NzU3MywiaWF0IjoxNTczNjczOTczLCJjdXN0b206dGVhbV9pZCI6IjEiLCJlbWFpbCI6InJjemVpZW5AZ21haWwuY29tIn0.d9FdLEnIW79ZMeSSM-0N1weXr7RJpdk6BD88EHmHk3LimweIWh96BWinMoK1f5cqZfcCjn_-cFhm-3hItrtEtZn8x0TSBm0j9DPujOL76uLml3GTpzqGaPN6wfa0p3nUAUKivOyhxsBMs5kbc03ectdHuLv5FiDKZ3o1DS852S4pE3s-ztfa5dRBgskfyh2dLoFEkTvQpbjFP9s2hloxOssqKtOs-pugSrjXgsErZ2l3dupOImHWdF8yHSBvVn8t5gipbDoflpKZpu1RKcLtLG2-gxoMMV6Pgk2iw-nfgq6Qm-NC2OmGvjNU3ds3Pmt99pChYapsogBIUoY0solYTw&access_token=eyJraWQiOiI5RE1pR05iTDBvY084T2pnZkhwOTBPU09tZGN2bDcreVFHRnBNOHVYUUhVPSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiI2NzM0YmE1My00NTAyLTQ0ODYtYThhNC1iNTRmYjBmYjJmYmUiLCJldmVudF9pZCI6IjhiODA1MjkxLTc5MmQtNDFiZS1hODIzLWY3MmI1OWEyMmU4MyIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4gcGhvbmUgb3BlbmlkIHByb2ZpbGUgZW1haWwiLCJhdXRoX3RpbWUiOjE1NzM2NzM5NzMsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy1lYXN0LTIuYW1hem9uYXdzLmNvbVwvdXMtZWFzdC0yX0MwQUkxRlBlSyIsImV4cCI6MTU3MzY3NzU3MywiaWF0IjoxNTczNjczOTczLCJ2ZXJzaW9uIjoyLCJqdGkiOiI0MmZkNGFkMi0xMTI3LTQzOGEtYjQ2MC02Yzc2MTQ1MDJlOWIiLCJjbGllbnRfaWQiOiI1czZlcGxrcHZvOGFhdGFiYmRrNzkwb3U2aSIsInVzZXJuYW1lIjoiNjczNGJhNTMtNDUwMi00NDg2LWE4YTQtYjU0ZmIwZmIyZmJlIn0.iEImwEMApQE-ZwfZkCNcssSpTFkTp7DNnC6ZuUocv829Um4MYj9tpAXE_Tt85OgnJORqcIR944EmgUlPrz8jOdCnd_C3-azqsLLSPQkCnDxUtisCHs-GQgOM5NSWug5XiiP7RD5xQcf6viIPxwLBKP8RgaBbQOGb1UyUmJjnnvPX6frSUxuypW4eEHQ2viBW_0ybIh36abQHzJxRqrfDBoTP1TsAZgW4pr4hS9yUm59r5c4gMtj_-vUPkkmUwHXMeAFwNN7kEZ4WyeXGlUfbHZu6EhpEqC7V0lUHWMntfkWY0-q6xx8-tH5DjKsKwAMIthTmdQzNioMbtscX_6Afyg&expires_in=3600&token_type=Bearer'
    console.log('current url: ' + curUrl)
    let authParsed = auth.parseCognitoWebResponse(curUrl)
    console.log(auth)
    */

    let teamId = store.getters.authTeamId
    let userId = store.getters.authUserId
    axios.defaults.headers.common['X-ChatAcuity-User'] = userId
    // {headers: { 'X-ChatAcuity-User': store.getters.authUserId}}
    axios.get('/teams/' + teamId)
      .then(response => {
        store.commit('teamMeta', response.data.data)
      })

  }
})
